import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, signal } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class Footer  implements AfterViewInit{
  activeDropdown = signal<string | null>(null);
  
quickLinks = [
    { title: 'About Us', route: 'about' },
    { title: 'Privacy Policy', route: 'policy' },
    { title: 'Terms & Conditions', route: 'terms' },
    { title: 'Contact Us', route: 'contact' },
  ];

  ourBrands = [
    { title: 'WellGro', route: 'wellgro' },
    { title: 'WellPro', route: 'wellpro' },
    { title: 'BWell', route: 'bewell' },
    { title: 'BreathePure', route: 'breathepure' },
  ];
  ngAfterViewInit(): void {
     // Add the "active-drop-footer" class to all `.cr-footer-links` elements
    const footerLinks = document.querySelectorAll('.cr-footer-links');
    footerLinks.forEach((link) => {
      link.classList.add('active-drop-footer');
    });

    // Append the dropdown toggle icon to all `.cr-sub-title` elements
    const subTitles = document.querySelectorAll('.cr-sub-title');
    subTitles.forEach((title) => {
      const icon = document.createElement('div');
      icon.className = 'cr-heading-res';
      icon.innerHTML = `<i class="ri-arrow-down-s-line" style="color: white !important;" aria-hidden="true"></i>`;
      title.appendChild(icon);

      // Add click event listener for toggling dropdowns
      icon.addEventListener('click', () => {
        const dropdown = title.closest('.footer-top .cr-footer-border')?.querySelector('.cr-footer-dropdown');
        if (dropdown) {
          const dropdownId = dropdown.id || Math.random().toString(36).substring(2); // Generate an ID if not present
          dropdown.id = dropdownId;

          // Toggle the clicked dropdown
          if (this.activeDropdown() === dropdownId) {
            this.activeDropdown.set(null); // Close the dropdown
          } else {
            this.activeDropdown.set(dropdownId); // Open the dropdown
          }

          // Update the dropdown visibility
          this.updateDropdownVisibility();
        }
      });
    });
  }

   // Update dropdown visibility based on the activeDropdown signal
  private updateDropdownVisibility(): void {
    const dropdowns = document.querySelectorAll('.cr-footer-dropdown');
    dropdowns.forEach((dropdown) => {
      if (dropdown.id === this.activeDropdown()) {
        (dropdown as HTMLElement).style.display = 'block'; // Show the active dropdown
      } else {
        (dropdown as HTMLElement).style.display = 'none'; // Hide other dropdowns
      }
    });
  }


}